export default "__VITE_ASSET__BWIH63zi__"